// extracted by mini-css-extract-plugin
export default {"headerContainer":"gweLayout_headerContainer__51rKQ","content":"gweLayout_content__HJn9q","description":"gweLayout_description__9I1t1"};